/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringcontainsexactoraspect17Inputs */

const de__class_stringcontainsexactoraspect17 = /** @type {(inputs: _Class_Stringcontainsexactoraspect17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet eins von (exakt)`)
};

/**

* @param {_Class_Stringcontainsexactoraspect17Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringcontainsexactoraspect17 = /** @type {((inputs?: _Class_Stringcontainsexactoraspect17Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringcontainsexactoraspect17Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringcontainsexactoraspect17(inputs)
});
export { _class_stringcontainsexactoraspect17 as "_class_StringCONTAINSEXACTORAspect" }